import objectReduce from 'fast-loops/lib/objectReduce';

export default {
  create: function create(styleSheet) {
    return objectReduce(styleSheet, function (ruleSheet, rule, ruleName) {
      if (typeof rule === 'function') {
        ruleSheet[ruleName] = rule;
      } else {
        ruleSheet[ruleName] = function () {
          return rule;
        };
        ruleSheet[ruleName].ruleName = ruleName;
      }

      return ruleSheet;
    }, {});
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/node_modules/fela-tools/es/StyleSheet.js
// module id = 1145
// module chunks = 0